import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Root from '@components/root/Root'
import Header from '@components/header/Header'
import Icon from '@components/icon/Icons'

import useNavigation from '@layout/useNavigation'
import useBreakpoint from '@utils/useBreakpoints'
import theme from '@theme/Theme'

const SiteScreen = () => {
  const navigation = useNavigation()
  const [, bp] = useBreakpoint()
  const isPhone = bp === 'phone'

  return (
    <Root onLeft={navigation.goBack} header="Todo">
      {!isPhone && <Header title="Todo" />}
      <Container>
        <Icon name="viparis" size={48} color={theme.colors.primary} />
        <Soon>Prochainement...</Soon>
      </Container>
    </Root>
  )
}

export default SiteScreen

const Container = styled(View)`
  padding: 96px 16px;
  justify-content: center;
  align-items: center;
`

const Soon = styled(Text)`
  ${(props) => props.theme.fonts.Title2};
  text-align: center;
  margin-top: 24px;
`
